// Team manager's tabs (Amir, 26 Oct): Who's working, Time off and Hours worked are one page in
// Schedule's rail until the team calendar is built (BL-159). Only the tabs this person opens.
import { Segmented } from '@flowology/ui-web/fl';
import { canOpenIn, TEAM_TABS } from '../blueprint/places.ts';
import type { NavProps, View } from '../Nav.tsx';
import './team-tabs.css';

export function TeamTabs({ nav }: { nav: Pick<NavProps, 'view' | 'permissions' | 'onView'> }) {
  const opens = canOpenIn(nav.permissions ?? []);
  const tabs = TEAM_TABS.filter((t) => opens(t.view));
  if (tabs.length < 2) return null;
  return (
    <nav className="bp-team-tabs" aria-label="Team manager">
      <Segmented
        label="Team manager’s pages"
        selectionMode="none"
        items={tabs.map((t) => ({ id: t.view, label: t.label }))}
        on={nav.view}
        onAction={(id) => {
          if (id !== nav.view) nav.onView(id as View);
        }}
      />
    </nav>
  );
}
